<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import BudgetProposalModal from "@/components/modals/budget-proposal-modal";
import RawData from "@/components/widgets/raw-data.vue";
import Swal from "sweetalert2";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import { groupBy } from "lodash";
export default {
    page: {
        title: "Budget Proposal Template",
    },
    components: {
        Layout,
        PageHeader,
        BudgetProposalModal,
        RawData,
        AttachmentModal
    },
    data() {
        return {
            title: "Budget Proposal Template",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Budget Proposal Template",
                    active: true,
                },
            ],
            filter: "",
            years: [],
            templates: [],
            selectedYear: null,
            frontPage: true,
            selectedTemplate: null,
            proposals: [],
            loadProposals: false,
            filterDUs: "",
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            budgets: []
        };
    },
    async created() {
        await this.getTemplates();
        await this.getBudgets();
        this.setTemplatesByYear(this.$store.state.data.cycle);
    },
    computed: {
        filteredProposals() {
            let data = this.proposals;
            if (this.filterDUs) {
                data = data.filter(proposal => proposal.deliveryUnit.toLowerCase().includes(this.filterDUs.toLowerCase()));
            }
            let grp = groupBy(data, "campusId");
            return Object.keys(grp).map(key => {
                return {
                    campusId: key,
                    campusName: grp[key][0].campus,
                    dus: grp[key]
                }
            });
        }
    },
    methods: {
        async getBudgets(){
            await this.$store
                .dispatch("accountgroups/getAllAccountGroup")
                .then((response) => {
                    if(response.error){
                        return this.showToast(response.errorMessage, "error");
                    }
                    let expenses = response.data.filter(x => x.accountType?.toLowerCase().includes('expense'));
                    this.budgets = expenses;
                })
                .catch(() => {
                    this.showToast("Something went wrong. Cannot fetch available PREXCs", "error");
                });
        },
        async getTemplates() {
            try {
                const {data: response} = await this.$store.dispatch("budgetproposaltemplate/GetAllBudgetProposalTemplates");
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                this.templates = response;
            } catch (error) {
                this.showToast("Error fetching templates", "error");
            }
        },
        setTemplatesByYear(currentCycle) {
            this.years = [];
            const currentYear = JSON.parse(currentCycle);
            for (let i = currentYear; i <= currentYear + 2; i++) {
                this.years.push({
                    year: i,
                    templates: this.templates.filter(template => template.cycle == i),
                });
            }
        },
        recreateYears() {
            this.years = this.years.map(yearObj => {
                return {
                    ...yearObj,
                    templates: this.templates.filter(template => template.cycle == yearObj.year),
                };
            });
        },
        createTemplate(year) {
            this.selectedYear = year;
            this.$bvModal.show("budget-proposal-modal");
            this.$refs.bpModal.resetForm();
        },
        async submitTemplate(modalData){
            modalData.cycle = this.selectedYear;
            if(modalData.id == 0){
                try{
                    const {data: response} = await this.$store.dispatch("budgetproposaltemplate/CreateBudgetProposalTemplate", modalData);
                    if(response.error){
                        this.showToast(response.errorMessage, "error");
                        return;
                    }
                    this.templates.push(response);
                    this.recreateYears();
                    this.showToast("Template created successfully", "success");
                    this.$bvModal.hide("budget-proposal-modal");
                }catch(error){
                    this.showToast("Error updating template", "error");
                }
            } else {
                try{
                    const {data: response} = await this.$store.dispatch("budgetproposaltemplate/UpdateBudgetProposalTemplate", modalData);
                    if(response.error){
                        this.showToast(response.errorMessage, "error");
                        return;
                    }
                    let index = this.templates.findIndex(x => x.id == modalData.id);
                    if(index !== -1){
                        this.templates.splice(index, 1, modalData);
                    }
                    this.recreateYears();
                    this.showToast("Template updated successfully", "success");
                    this.$bvModal.hide("budget-proposal-modal");
                }catch(error){
                    this.showToast("Error updating template", "error");
                }
            }
        },
        editTemplate(template) {
            this.selectedYear = template.cycle;
            this.$bvModal.show("budget-proposal-modal");
            this.$refs.bpModal.updateData(template);
        },
        deleteTemplate(template) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const {data: response} = await this.$store.dispatch("budgetproposaltemplate/RemoveBudgetProposalTemplate", template.id);
                        if(response.error){
                            this.showToast(response.errorMessage, "error");
                            return;
                        }
                        let index = this.templates.findIndex(x => x.id == template.id);
                        if(index !== -1){
                            this.templates.splice(index, 1);
                        }
                        this.recreateYears();
                        this.showToast("Template deleted successfully", "success");
                    } catch (error) {
                        this.showToast("Error deleting template", "error");
                    }
                }
            });
        },
        filterTemplates(templates) {
            if (!this.filter) return templates;
            return templates.filter(template => template.description.toLowerCase().includes(this.filter.toLowerCase()));
        },
        async getPostedProposals(temp) {
            try{
                const { data: response } = await this.$store.dispatch("budgetproposaltemplate/GetPostedProposals", temp.id);
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.map(x => {
                    x.showTargets = false;
                    x.targets = [];
                    x.targetLoading = false;
                    return x;
                });
                this.proposals = response;
            }catch(err){
                this.showToast("Error fetching proposals", "error");
            }
        },
        async getTargets(opcr) {
            try{
                const { data: response } = await this.$store.dispatch("planningapi/GetAllPlanningApis", opcr.id);
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.forEach((x) => {
                    x.sort = 3;
                    if(x.type.toLowerCase().includes('strategic')){
                        x.sort = 1;
                    }else if(x.type.toLowerCase().includes('core')){
                        x.sort = 2
                    }
                    x.showApis = x.planningApis.length;
                    x.filterKey = `${x.planningTarget}`;
                    x.planningApis.map(item => {
                        item.showAttachments = false;
                        item.attachmentLoading = false;
                        item.addDocu = false;
                        item.fileSearch = "";
                        item.attachments = [];
                        item.totalResources = this.formatCurrency(item.total);
                        item.selected = false;
                        x.filterKey += ` ${item.name}`;
                        item.filterKey = `${x.planningTarget} ${item.name}`;
                        item.showResources = false;
                        item.resources = [];
                        item.searchItem = "";
                        return item;
                    }).sort((a, b) => a.name.localeCompare(b.name))
                });
                opcr.targets = response.sort((a, b) => a.planningTarget.localeCompare(b.planningTarget)).sort((a, b) => a.sort - b.sort);
            }catch(err){
                this.showToast("Error fetching targets", "error");
            }
        },
        async viewProposal(temp) {
            this.frontPage = false;
            this.selectedTemplate = temp;
            this.proposals = [];
            this.loadProposals = true;
            await this.getPostedProposals(temp);
            this.loadProposals = false; 
        },
        async viewTargets(opcr) {
            opcr.showTargets = !opcr.showTargets;
            if(opcr.showTargets && !opcr.targets.length){
                opcr.targetLoading = true;
                await this.getTargets(opcr);
                opcr.targetLoading = false;
            }
        },
        filteredApis(targets, filter) {
            let data = targets;
            if (filter && filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(filter.toUpperCase());
                });
            }
            var groupedClass = groupBy(data, "type");
            var classID = 1;
            var grouped = [];
            for (const key in groupedClass) {
                grouped.push({
                    id: classID++,
                    data: groupedClass[key],
                    key: key,
                });
            }
            return grouped;
        },
        filterApiCards(apis, filter) {
            let data = apis;
            if(filter && filter.trim() !== ''){
                data = data.filter(x => {
                    return x.filterKey.toUpperCase().includes(filter.toUpperCase());
                })
            }
            return data;
        },
        async viewResources(api) {
            api.showResources = !api.showResources;
            if(api.showResources && !api.resources.length){
                api.itemLoading = true;
                await this.getResourceDetails(api);
                api.itemLoading = false;
            }
        },
        async getResourceDetails(api) {
            try{
                const { data: response } = await this.$store.dispatch("planningapiresource/GetPlanningApiResourcesByApi", api.id);
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.forEach((item) => {
                    let budgetInfo = this.budgets.find((x) => x.id == item.accountGroupId);
                    item.totalQuantity = item.planningApiResourceDetails.reduce((pv, cv) => {
                        return (parseFloat(pv) + parseFloat(cv.quantity));
                    }, 0);
                    item.financeTemplateBudgetItem = {
                        fundSource: budgetInfo.fundSource,
                        fundClass: budgetInfo.fundClassification.classification,
                        fundClassification: budgetInfo.fundClassification,
                        groupName: budgetInfo.groupName,  
                        accountGroup: budgetInfo.groupName,
                        accountId: budgetInfo.id,
                        id: budgetInfo.id
                    };
                    item.showRow = true;
                    item.showChild = true;
                    item.filterKey = `${item.itemName} ${item.description}`;
                });
                api.resources = response;
            }catch(err){
                this.showToast("Error fetching resources", "error");
                return;
            }
        },
        filteredItems(items, filter) {
            let data = items;
            if(filter && filter.trim() !== ''){
                data = data.filter(x => {
                    return x.filterKey.toUpperCase().includes(filter.toUpperCase());
                })
            }
            return data;
        },
        async showApiAttachments(api){
            this.$bvModal.show("upload-attachment-modal");
            this.$refs.attachmentModal.setUploadOpt({
                type: "API Special Projects",
                placement: "left",
                folder: "Office",
            });
            await this.$refs.attachmentModal.getData(api.id);
        },
    },
}
</script>
<template>
    <Layout @changeCycle="setTemplatesByYear($event)">
        <PageHeader :title="title" :items="items" />
        <template v-if="frontPage">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <div class="d-flex gap-1">
                    <b-form-input
                        autocomplete="off"
                        v-model="filter"
                        type="search"
                        placeholder="Search Template..."
                        class="form-control w-auto"
                    ></b-form-input>
                </div>
            </div>
            <div>
                <div v-for="x in years" :key="x.year" class="mb-4">
                    <h5>Year {{ x.year }}</h5>
                    <template v-if="x.templates.length == 0">
                        <div 
                            class="broken-border py-5 d-flex align-items-center justify-content-center br-5 cursor-pointer hover-underline" 
                            @click="createTemplate(x.year)"
                        >
                            <h5 class="text-muted mb-0 "><i class="bx bx-plus"></i>Create New Template ({{ x.year }})</h5>
                        </div>
                    </template>
                    <template v-else>
                        <b-card no-body v-for="y in filterTemplates(x.templates)"  :key="y.id" class="mb-2 hover-toggle">
                            <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" />
                            <b-card-header class="py-4">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <h4 class="mb-2">{{ y.description }}</h4>
                                        <span v-for="z in y.campuses" :key="z.id" class="bg-success py-0 px-2 me-1 br-5 text-white">{{ z.campusName }}</span>
                                        <div class="mt-2">
                                            <a href="javascript:void(0);" class="mb-0 d-flex align-items-center" @click="viewProposal(y)">View Proposals <i class="bx bx-chevron-right"></i></a>
                                        </div>
                                    </div>
                                    <div class="hover-content">
                                        <a href="javascript:void(0);" title="Edit Template" @click="editTemplate(y)">
                                            <i class="bx bx-edit text-success font-size-22"></i>
                                        </a>
                                        <a href="javascript:void(0);" title="Delete Template" @click="deleteTemplate(y)">
                                            <i class="bx bx-trash text-danger font-size-22"></i>
                                        </a>
                                    </div>
                                </div>
                            </b-card-header>
                        </b-card>
                        <div class="text-center">
                            <a href="javascript:void(0);" @click="createTemplate(x.year)"><i class="bx bx-plus"></i>Add More Template for {{ x.year }}</a>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="d-flex align-items-center gap-3 mb-4">
                <a href="javascript:void(0);" @click="frontPage = true" class="d-flex align-items-center gap-1"><i class="bx bx-chevron-left"></i> Back</a>
                <h4 class="mb-0">{{ selectedTemplate.description }} - Proposals</h4>
            </div>
            <template v-if="loadProposals">
                <div class="d-flex align-items-center justify-content-center" style="height: 300px;">
                    <b-spinner label="Loading..."></b-spinner>
                </div>
            </template>
            <template v-else>
                <template v-if="!proposals.length">
                    <div class="d-flex align-items-center justify-content-center flex-column" style="height: 300px;">
                        <h5 class="text-muted">No proposals available.</h5>
                    </div>
                </template>
                <template v-else>
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <div id="tickets-table_filter" class="dataTables_filter me-1">
                            <label class="d-inline-flex align-items-center mb-0">
                                <b-form-input
                                    autocomplete="off"
                                    v-model.lazy="filterDUs"
                                    type="search"
                                    placeholder="Search Delivery Unit..."
                                    class="form-control"
                                    style="width:250px;"
                                ></b-form-input>
                                <b-form-select
                                    class="form-select mx-1"
                                    v-model="perPage"
                                    size="sm"
                                    :options="pageOptions"
                                    style="width:70px;"
                                ></b-form-select>
                            </label>
                        </div>
                    </div>
                    <div>
                        <ul class="px-0 mx-3">
                            <li v-for="x in filteredProposals" :key="x.campusId">
                                <h4>{{ x.campusName }}</h4>
                                <div class="ms-3">
                                    <div
                                        role="tablist"
                                        v-for="(opcr, opcrIndex) in x.dus"
                                        :key="opcr.id"
                                    >
                                        <b-card
                                            no-body
                                            class="mb-2"
                                            :style="{ 'z-index': x.dus.length - opcrIndex }"
                                        >
                                            <RawData :data="opcr" v-if="$store.state.decrypt.isAdmin()" />
                                            <b-card-header
                                                header-tag="header"
                                                role="tab"
                                                header-class="py-3 cursor-pointer hover-bg"
                                                @click="viewTargets(opcr)"
                                            >
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <h6 class="m-0">
                                                        <a class="text-dark py-2" href="javascript: void(0);">
                                                            <p class="text-info font-size-18 mb-2" >{{ opcr.deliveryUnit }}</p>
                                                            <p class="text-white font-size-16 mb-1">{{opcr.description}}</p>
                                                            <p class="font-size-12 mb-0">Total Amount: <span class="text-orange font-weight-bold">{{formatCurrency(opcr.totalAmount)}}</span></p>
                                                        </a>
                                                    </h6>
                                                    <div class="d-flex align-items-center">
                                                        <div>
                                                            <span class="d-flex align-items-center text-truncate">
                                                                <small v-if="!opcr.showTargets">Click to view Targets & APIs</small>
                                                                <i class="bx bx-chevron-right rotate font-size-18 ms-3" :class="{'rotate-90': opcr.showTargets}"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-card-header>
                                            <b-collapse
                                                :visible="opcr.showTargets"
                                                :accordion="`opcr-${opcr.id}`"
                                                role="tabpanel"
                                            >
                                                <b-card-body class="border-top">
                                                    <div v-if="opcr.showTargets" class="">
                                                        <div class="mb-3 d-flex">
                                                            <div class="w-300px ">
                                                                <input 
                                                                    class="form form-control" 
                                                                    type="text"
                                                                    placeholder="Search Target"
                                                                    v-model="opcr.searchTarget"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <template v-if="opcr.targetLoading">
                                                                <div class="d-flex align-items-center justify-content-center" style="height: 300px;">
                                                                    <b-spinner label="Loading..."></b-spinner>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="!opcr.targets.length">
                                                                    <div class="d-flex align-items-center justify-content-center flex-column" style="height: 300px;">
                                                                        <h5 class="text-muted">No targets available.</h5>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <b-tabs nav-class="nav-tabs-custom" content-class="pt-0 px-2 text-muted">
                                                                        <b-tab v-for="x in filteredApis(opcr.targets, opcr.searchTarget)" :key="x.id">
                                                                            <template v-slot:title>
                                                                                {{x.key}}
                                                                            </template>
                                                                            <div v-for="(z, zIndex) in x.data" :key="`${x.id}Z-${zIndex}`" class="mt-2">
                                                                                <hr v-if="zIndex != 0" class="py-0 my-1">
                                                                                <template v-if="z.showApis">
                                                                                    <hr class="mt-1 mb-2">
                                                                                    <h5 no-body class="mb-2">{{x.data.length ? `List of API's` : 'No data found'}}</h5>
                                                                                    <template v-for="(w, wIndex) in filterApiCards(z.planningApis, opcr.searchTarget)">
                                                                                        <div :key="`API-B-${w.id}`" class="ms-3">
                                                                                            <b-card no-body :style="{zIndex: `${x.data.length - zIndex}${opcr.targets.length - wIndex}`}" class="mb-2 shadow-none border">
                                                                                                <RawData v-if="$store.state.decrypt.isAdmin()" :data="w" />
                                                                                                <b-card-header @click="viewResources(w)">
                                                                                                    <div class="d-flex justify-content-between align-items-center">
                                                                                                        <div>
                                                                                                            <span class="d-block cursor-pointer text-hover" >{{w.name}}
                                                                                                                <span v-if="w.fromModification" class="font-size-10 text-green">[From Modification]</span>
                                                                                                                <sup v-if="w.departmentName" class="badge bg-purple">{{w.departmentName}}</sup>
                                                                                                            </span>
                                                                                                            <small class="d-block" v-if="w.description">[{{w.description}}]</small>
                                                                                                            <small>Total: {{w.totalResources}}</small>
                                                                                                            <small class="d-block"><a href="javascript:void(0)" class="text-yellow" @click.stop="showApiAttachments(w)">[Attachments]</a></small>
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <span class="d-flex align-items-center text-truncate">
                                                                                                                <small v-if="!w.showResources">Click to view resources</small>
                                                                                                                <i class="bx bx-chevron-right rotate font-size-18 ms-3" :class="{'rotate-90': w.showResources}"></i>
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </b-card-header>
                                                                                                <b-collapse
                                                                                                    :visible="w.showResources"
                                                                                                    :accordion="`api-${w.id}`"
                                                                                                    role="tabpanel"
                                                                                                >
                                                                                                    <b-card-body class="border-top">
                                                                                                        <div class="mb-3 d-flex gap-1">
                                                                                                            <div class="w-300px ">
                                                                                                                <input 
                                                                                                                    class="form form-control" 
                                                                                                                    type="text"
                                                                                                                    placeholder="Search Resource"
                                                                                                                    v-model="w.searchItem"
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div class="table-responsive">
                                                                                                            <table class="table project-list-table table-centered table-borderless align-middle">
                                                                                                                <thead>
                                                                                                                    <tr>
                                                                                                                        <th scope="col">Item Name</th>
                                                                                                                        <th scope="col" width="150px" class="text-center">Quantity</th>
                                                                                                                        <th scope="col" width="170px">Unit Cost</th>
                                                                                                                        <th scope="col" width="170px">Total</th>
                                                                                                                    </tr>
                                                                                                                </thead>
                                                                                                                <tbody>
                                                                                                                    <tr v-if="w.resourceLoading">
                                                                                                                        <td colspan="100%">
                                                                                                                            <div class="d-flex justify-content-center align-items-center">
                                                                                                                                <div class="preloader-component me-2">
                                                                                                                                    <div class="status">
                                                                                                                                        <div class="spinner-chase w-20px h-20px">
                                                                                                                                            <div class="chase-dot"></div>
                                                                                                                                            <div class="chase-dot"></div>
                                                                                                                                            <div class="chase-dot"></div>
                                                                                                                                            <div class="chase-dot"></div>
                                                                                                                                            <div class="chase-dot"></div>
                                                                                                                                            <div class="chase-dot"></div>
                                                                                                                                        </div>
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                                <strong>Loading...</strong>
                                                                                                                            </div>
                                                                                                                        </td>
                                                                                                                    </tr>
                                                                                                                    <tr v-if="w.resources.length == 0 && !w.resourceLoading">
                                                                                                                        <td
                                                                                                                            colspan="100%"
                                                                                                                            class="text-muted text-center"
                                                                                                                        >
                                                                                                                            <i class="dripicons-warning me-1"></i>No data found
                                                                                                                        </td>
                                                                                                                    </tr>
                                                                                                                    <tr v-if="filteredItems.length == 0 && !w.resourceLoading && w.resources.length > 0">
                                                                                                                        <td
                                                                                                                            colspan="100%"
                                                                                                                            class="text-muted text-center"
                                                                                                                        >
                                                                                                                            <i class="dripicons-warning me-1"></i>Search not found
                                                                                                                        </td>
                                                                                                                    </tr>
                                                                                                                    <tr 
                                                                                                                        v-for="x in filteredItems(w.resources, w.searchItem)" 
                                                                                                                        :key="x.id"
                                                                                                                        :ref="`resource-tr-${x.id}`"
                                                                                                                    >
                                                                                                                        <td 
                                                                                                                            class="border border-end-0 position-relative"
                                                                                                                        >
                                                                                                                            <RawData :data="x"/>
                                                                                                                            <div class="d-flex align-items-center">
                                                                                                                                <div class="ms-2">
                                                                                                                                    <div>
                                                                                                                                        <label class="form-check-label" :for="`selected-${x.id}`">
                                                                                                                                            {{ x.itemName }}
                                                                                                                                        </label>
                                                                                                                                    </div>
                                                                                                                                    <small>{{x.description}}</small>
                                                                                                                                    <small class="d-block text-yellow" v-if="x.note">({{x.note}})</small>
                                                                                                                                    <div>
                                                                                                                                        <small>
                                                                                                                                            <i>{{ x.itemCategory.name || x.itemCategory }}</i>
                                                                                                                                            <span class="text-warning ms-1">[{{x.isProcurable ? 'Procurable' : 'Non-procurable' }}]</span>
                                                                                                                                            <span class="text-warning ms-1" v-if="x.isMixed">[Mixed]</span>
                                                                                                                                            <span class="text-warning ms-1" >[{{x.type}}]</span>
                                                                                                                                        </small>
                                                                                                                                    </div>
                                                                                                                                    <div class="d-inline align-items-center mb-1">
                                                                                                                                        <span class="badge bg-purple text-white py-1 px-2 me-2">
                                                                                                                                            {{   x.financeTemplateBudgetItem.fundClass }}
                                                                                                                                        </span>
                                                                                                                                        <span class="badge bg-success text-white py-1 px-2 me-2">
                                                                                                                                            {{  x.financeTemplateBudgetItem.accountGroup }}
                                                                                                                                        </span>
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </td>
                                                                                                                        <td class="border border-start-0 border-end-0 text-center">{{ numberWithCommas(x.totalQuantity) }}</td>
                                                                                                                        <td class="border border-start-0 border-end-0"
                                                                                                                        >
                                                                                                                            {{ formatCurrency(x.inflatedUnitCost) }}
                                                                                                                            <div v-if="x.totalInflation != 0">
                                                                                                                                <small class="d-block">Orig. Cost: <span class="text-warning">{{formatCurrency(x.unitCost)}}</span></small>
                                                                                                                                <small class="d-block" v-if="!department">Inflation: {{x.unitCostWithInflation ? formatCurrency(x.unitCostWithInflation) : formatCurrency(parseFloat(x.inflatedUnitCost) - parseFloat(x.unitCost))}}</small>
                                                                                                                                <small class="d-block" v-else>Inflation: {{formatCurrency(x.unitCostInflation)}}</small>
                                                                                                                            </div>
                                                                                                                        </td>
                                                                                                                        <td 
                                                                                                                            class="border border-start-0 border-end-0"
                                                                                                                        >
                                                                                                                            {{ formatCurrency(parseFloat(x.totalWithInflation)) }}
                                                                                                                            <div v-if="x.totalInflation != 0">
                                                                                                                                <small>Inflation: {{formatCurrency(x.totalInflation)}}</small>
                                                                                                                            </div>
                                                                                                                        </td>
                                                                                                                    </tr>
                                                                                                                </tbody>
                                                                                                            </table>
                                                                                                        </div>
                                                                                                    </b-card-body>
                                                                                                </b-collapse>
                                                                                            </b-card>
                                                                                        </div>
                                                                                    </template>
                                                                                </template>
                                                                            </div>
                                                                        </b-tab>
                                                                    </b-tabs>
                                                                </template>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </b-card-body>
                                            </b-collapse>
                                        </b-card>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </template>
            </template>
        </template>
        <BudgetProposalModal ref="bpModal" @submit="submitTemplate" />
        <attachment-modal
            :wActions="true"
            title="API Attachments"
            ref="attachmentModal"
        ></attachment-modal>
    </Layout>   
</template>